(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aside-cart-backup-2026"]) return;
  try {
    
  const other_products_cart = document.getElementById('other_products_cart');

    const otherProductsCartCarouselSettings = {
        type: 'slide',
        rewind: false,
        autoHeight: false, 
        perPage: 1,
        start: 0,
        autoplay: false,
        interval: 3200,
        speed: 600,
        pauseOnHover: true,
        gap: 24,
        arrows: true,
        trimSpace: true,
        pagination : false,
    }

    if (other_products_cart) {
      const otherProductsCartCarousel = new Splide(other_products_cart, otherProductsCartCarouselSettings);
      otherProductsCartCarousel.mount();
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aside-cart"]) return;
  try {
    
  // "Doplňte si svoj systém" in the cart: buttons are re-rendered with the cart items, so listen on the document
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.cart-combo__add');
    if (!btn || typeof manageCart === 'undefined') return;
    event.preventDefault();
    manageCart.addToCart(btn, { id: btn.dataset.variantId, quantity: 1 });
  });

  // Výhodný set in the cart: remove the single products and add the set instead (snippet cart-set-offer)
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-set-swap]');
    if (!btn || typeof manageCart === 'undefined') return;
    event.preventDefault();
    btn.classList.add('is-busy');
    try {
      const updates = {};
      btn.dataset.remove.split(',').filter(Boolean).forEach((key) => { updates[key] = 0; });
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: Number(btn.dataset.quantity) }] }) });
    } catch (e) {
      console.error('[set swap]', e);
    }
    await manageCart.updateCartDisplay(true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-circle-group"] && !Shopify.designMode) return;
  try {
    

const initGsap = ( accordion ) => {
    items = accordion.querySelectorAll('.ac');
    items.forEach((item, index) => { 
        if( index % 2 == 0 ) {
            gsap.from(item, {
            y: '100%',
            opacity: 0, 
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: item,
              start: "top 100%", 
              toggleActions: "play none none none",
            },
          });
        }
        else {
          gsap.from(item, {
            y: '100%',
            opacity: 0, // Start opacity
            duration: 1, // Animation duration
            ease: "power2.out",
            scrollTrigger: {
              trigger: item, // Trigger the animation when this element enters
              start: "top 100%", // When the top of box reaches 80% of viewport height
              toggleActions: "play none none none", // Play only once
            },
          });
        }      
    });
  }    


  const accords = document.querySelectorAll('.faq-ac');
  accords.forEach( item => {
    new Accordion( item , {
      showMultiple: false,
    });

    if (item != accords[0]) {
      initGsap( item );
    }
  })





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    (function () {
      var header = document.querySelector('.th-header-overlay');
      if (!header) return;
      var update = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
      update();
      window.addEventListener('scroll', update, { passive: true });
    })();

    if (document.getElementById('info_bar_splide')) {
      new Splide('#info_bar_splide', {
        type   : 'loop',
        drag   : 'free',
        focus  : 'center',
        perPage: 3,
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: .2,
        },
      }).mount( window.splide.Extensions );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-custom-reviews"] && !Shopify.designMode) return;
  try {
    

document.addEventListener( 'DOMContentLoaded', function() {

    const splideReviews = new Splide( '.splide-reviews', {
      perPage: 4,
      gap: 20,
      type: 'loop',
      pagination: false,
      speed: 860,
      arrows: false,
      drag: 'free',
      focus: 'center',
      autoScroll: {
          speed: 0.15,
          pauseOnHover: true,
      },


      breakpoints: {
        1024: {
          type: 'loop',
          perPage: 2,
          padding: { right: 90 }
        },
        640: {
          perPage: 1,
          padding: { right: 70 }
        },
      }
  });

  splideReviews.mount(window.splide.Extensions);


});

// const showOverlay = ( video ) => {
//   console.log( video );
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq-group"] && !Shopify.designMode) return;
  try {
    

const initGsap = ( accordion ) => {
    items = accordion.querySelectorAll('.ac');
    items.forEach((item, index) => {
        if( index % 2 == 0 ) {
            gsap.from(item, {
            y: '100%',
            opacity: 0, 
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: item,
              start: "top 100%", 
              toggleActions: "play none none none",
            },
          });
        }
        else {
          gsap.from(item, {
            y: '100%',
            opacity: 0, // Start opacity
            duration: 1, // Animation duration
            ease: "power2.out",
            scrollTrigger: {
              trigger: item, // Trigger the animation when this element enters
              start: "top 100%", // When the top of box reaches 80% of viewport height
              toggleActions: "play none none none", // Play only once
            },
          });
        }
    });
  }    

  const accords = document.querySelectorAll('.faq-ac');
  accords.forEach( item => {
    new Accordion( item , {
      showMultiple: false,
    });

    initGsap( item );
  })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq-image-group"] && !Shopify.designMode) return;
  try {
    


const mm = gsap.matchMedia();


const initGsap = ( accordion ) => {
    items = accordion.querySelectorAll('.ac');
    items.forEach((item, index) => {
        if( index % 2 == 0 ) {

        mm.add({
            isMobile: "(max-width: 1024px)",
            isDesktop: "(min-width: 1024px)"
          }, (context) => {
            let { isMobile } = context.conditions;
            gsap.from(item, {
              y: isMobile ? '10%' : '100%',
              opacity: 0, 
              duration: 1,
              ease: "power2.out",
              scrollTrigger: {
                trigger: item,
                start: "top 100%", 
                toggleActions: "play none none none",
              },
            });
        }) 
        }
        else {
          mm.add({
            isMobile: "(max-width: 1024px)",
            isDesktop: "(min-width: 1024px)"
          }, (context) => {
            let { isMobile } = context.conditions;
              gsap.from(item, {
                y: isMobile ? '10%' : '100%',
                opacity: 0, // Start opacity
                duration: 1, // Animation duration
                ease: "power2.out",
                scrollTrigger: {
                  trigger: item, // Trigger the animation when this element enters
                  start: "top 100%", // When the top of box reaches 80% of viewport height
                  toggleActions: "play none none none", // Play only once
                },
              });
            })
        }
    });
  }    
  

  const accords = document.querySelectorAll('.faq-ac');
  accords.forEach( item => {
    new Accordion( item , {
      showMultiple: false,
    });

    initGsap( item );
  })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ingredients-carousel"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener( 'DOMContentLoaded', function() {
   
    const primary = new Splide( '.splide-ingredients-thumbnail', {
      type: 'loop',
      autoHeight: true,
      perPage: 5,
      perMove: 1,
      focus: 'center',
      pagination: false,
      gap: 0,
      padding: 0,
      isNavigation: true,
      breakpoints: {
        1024: {
          perPage: 3,
        },
        600: {
          perPage: 1,
        },
      }
    } );

    const secondary = new Splide( '.splide-ingredients-description', {
      type: 'fade',
      autoHeight: true, 
      perPage: 1,
      perMove: 1,
      focus: 'center',
      pagination: false,
      arrows: false,
      gap: 65,
      breakpoints: {
        600: {
          perPage: 1,
          autoHeight: false
        },
      }
    } );

    const slides = document.querySelectorAll('.splide-ingredients-thumbnail .splide__slide');
    const activeClass = "custom-active";
    slides[0].classList.add(activeClass);
    
    secondary.mount();
    primary.sync( secondary );
    primary.mount();
    

    primary.on('move', function (newIndex, oldIndex) {          
        // Remove the class from the old slide
        if (slides[oldIndex]) {
            slides[oldIndex].classList.remove(activeClass);
        }

        // Add the class to the new slide
        if (slides[newIndex]) {
            slides[newIndex].classList.add(activeClass);
        }
    });
    
  } );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-benefits"] && !Shopify.designMode) return;
  try {
    
    new Accordion('.home-benefits-ac', {
      showMultiple: false,
    });


    const paginationWrapper = document.querySelector('.pagination-interval');
    const splideInterval = 5000;

    document.addEventListener( 'DOMContentLoaded', function() {
      const primary = new Splide( '.splide-photos', {
      type: 'loop',
      autoHeight: true,
      perPage: 1,
      autoplay: true,
      perMove: 1,
      interval: splideInterval,
      pagination: 'splide__pagination',
      arrows: false,
      gap: '1rem',
      });      

      const gsapAnimation = gsap.to(paginationWrapper, {
          duration: splideInterval/1000,
          '--after-width-benefits': '100%',
          ease: 'power1.inOut'
        });

        primary.on( 'autoplay:play', function ( rate ) {  
          gsapAnimation.play();      
        } );

      primary.on( 'move', function () {  
        gsapAnimation.progress(0).play();
      } );

      primary.mount();

    });

   


  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-bottle"] && !Shopify.designMode) return;
  try {
    
  gsap.registerPlugin(ScrollTrigger);
  const benefitItems = document.querySelectorAll(".benefit-item");

  const mm = gsap.matchMedia();

  mm.add({
    isMobile: "(max-width: 1024px)",
    isDesktop: "(min-width: 1024px)"
  }, (context) => {
    let { isMobile } = context.conditions;

    benefitItems.forEach((item) => {
      if( [...item.classList].includes('benefit-item-left') ) {
          gsap.from(item, {
          x: isMobile ? '100%' : '-100%',
          opacity: 0, 
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: item,
            start: "top 80%", 
            toggleActions: "play none none none",
          },
        });
      }
      else {
        gsap.from(item, {
          x: '100%',
          opacity: 0, // Start opacity
          duration: 1, // Animation duration
          ease: "power2.out",
          scrollTrigger: {
            trigger: item, // Trigger the animation when this element enters
            start: "top 80%", // When the top of box reaches 80% of viewport height
            toggleActions: "play none none none", // Play only once
          },
        });
      }
    });
  })

        gsap.from('.bottle', {
          opacity: 0,
          duration: 2, 
          ease: "power2.out",
          scrollTrigger: {
            trigger: '.bottle',
            start: "top 100%",
            toggleActions: "play none none none", 
          },
        });



  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-home-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const accordions = document.querySelectorAll('.home-faq-ac');
    accordions.forEach(accordion => {
      new Accordion(accordion, {
        showMultiple: false,
      });
    });
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-home-reviews"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener( 'DOMContentLoaded', function() {

    const splideInterval = 5000;
    const splide = new Splide( '.splide-reviews', {
      type: 'loop',
      autoHeight: true,
      perPage: 3,
      perMove: 1,
      autoplay: true,
      interval: splideInterval,
      focus: 0,
      gap: 24,
      pagination: 'splide__pagination',
      breakpoints: {
        1024: {
          autoHeight: true,
          perPage: 1,
          arrows: false,
        },
      }
    } );

    const paginationWrapper = document.querySelector('.pagination-interval-reviews');
    const gsapAnimation = gsap.to(paginationWrapper, {
        duration: splideInterval/1000,
        '--after-width': '100%',
        ease: 'power1.inOut'
      });

      splide.on( 'autoplay:play', function ( rate ) {  
        gsapAnimation.play();      
      } );

    splide.on( 'move', function () {  
      gsapAnimation.progress(0).play();
    } );

    splide.mount({});
  } );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-results"] && !Shopify.designMode) return;
  try {
    
  

  window.addEventListener("load", (event) => {
    const counterElements = document.querySelectorAll(".item-result");
    

    counterElements.forEach(element => {
    const target = element.getAttribute('attr-target');
    const targetNumber = parseInt(target.match(/\d+/)[0], 10);
    const targetAppend = target.replace(targetNumber, "").trim();

      const gsapCount = gsap.to({ value: 0 }, {
        value: targetNumber, // Target number
        duration: 2, // Duration of the animation
        ease: "sine.in",
        scrollTrigger: {
            trigger: element,
            start: "top 110%",
            toggleActions: "play none none none", 
          },
        onUpdate: function () {
          // Update the counter element with the rounded current value
          element.textContent = `${Math.floor(this.targets()[0].value)}${targetAppend}`;
        },
        onComplete: function () {
          // Ensure the final value is exactly the target number
          element.textContent = `${targetNumber}${targetAppend}`;
        }
      });

    });
  });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-stats"] && !Shopify.designMode) return;
  try {
    
  

  window.addEventListener("load", (event) => {
    const counterElements = document.querySelectorAll(".item-result");
    
   counterElements.forEach(element => {
        const target = element.getAttribute('attr-target');

        // Získa číslo (aj s desatinami)
        const numberMatch = target.match(/[\d.]+/);
        if (!numberMatch) return;

        const targetNumber = parseFloat(numberMatch[0]);

        // Zistí počet desatinných miest
        const decimals = (numberMatch[0].split('.')[1] || '').length;

        // Zvyšok (%, jednotky...)
        const targetAppend = target.replace(numberMatch[0], '').trim();

        gsap.to({ value: 0 }, {
          value: targetNumber,
          duration: 2,
          ease: "sine.in",
          scrollTrigger: {
            trigger: element,
            start: "top 110%",
            toggleActions: "play none none none",
          },
          onUpdate: function () {
            const v = this.targets()[0].value;
            element.textContent =
              `${v.toFixed(decimals)}${targetAppend}`;
          },
          onComplete: function () {
            element.textContent =
              `${targetNumber.toFixed(decimals)}${targetAppend}`;
          }
        });
      });
  });


  document.addEventListener('DOMContentLoaded', function () {

   const stats_carousel = document.getElementById('stats_carousel');

    const statsCarouselSettings = {
      perPage: 3,
      gap: 20,
      type: 'loop',
      pagination: false,
      speed: 860,
      arrows: false,
      drag: 'free',
      focus: 'center',
      autoScroll: {
        speed: 0.2,
        pauseOnHover: false,
      },
      breakpoints: {
        400: {
          perPage: 2,
        },
      }
    }

    const statsCarousel = new Splide(stats_carousel, statsCarouselSettings);
    statsCarousel.mount(window.splide.Extensions);

  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-user-gallery"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const galleryEl = document.querySelector('.splide-images');
  if (!galleryEl) return;

  // Splide sa mountuje presne raz, rovnako ako v pôvodnom kóde.
  const splideImages = new Splide('.splide-images', {
    type: 'loop',
    perPage: 5,
    perMove: 1,
    gap: 20,
    pagination: false,
    arrows: false,
    drag: 'free',
    focus: 'center',
    speed: 860,
    autoScroll: {
      speed: 0.15,
      pauseOnHover: true,
    },
    breakpoints: {
      1024: {
        type: 'loop',
        perPage: 2,
        padding: { right: 90 }
      },
      640: {
        perPage: 1,
        padding: { right: 70 }
      },
    }
  });

  splideImages.mount(window.splide.Extensions);

  // Namiesto búrania a znovu-vytvárania celého carouselu len
  // zapíname/vypíname autoScroll slučku podľa toho, či je galéria
  // reálne vidno. Carousel samotný (drag, loop, hover) ostáva
  // po celý čas nedotknutý.
  const autoScroll = splideImages.Components && splideImages.Components.AutoScroll;

  if (autoScroll) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          autoScroll.play();
        } else {
          autoScroll.pause();
        }
      });
    }, {
      rootMargin: '200px',
    });

    observer.observe(galleryEl);
  } else {
    console.warn('Splide AutoScroll komponent sa nenašiel — skontroluj, že sa extension skript načítava.');
  }

});

// const showOverlay = ( video ) => {
//   console.log( video );
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-user-videos"] && !Shopify.designMode) return;
  try {
    

document.addEventListener( 'DOMContentLoaded', function() {

    const splideVideos = new Splide( '.splide-videos', {
      type: 'slide',
      perPage: 5,
      perMove: 1,
      
      autoplay: false,
      pagination: false,
      arrows: false,
      gap: 20,
      breakpoints: {
        1024: {
          type: 'loop',
          perPage: 2,
          padding: { right: 90 }
        },
        640: {
          perPage: 1,
          padding: { right: 70 }
        },
      }
  });

  splideVideos.mount({});

  const videoOverlays = document.querySelectorAll('.section-videos .video-overlay');
  const allVideos = document.querySelectorAll('.section-videos video');
  splideVideos.on('moved', function() {
    allVideos.forEach((video, index) => {
      video.pause();
    });
  });

  allVideos.forEach((video, indexCurrent) => {
    video.classList.add('hide-controls');
    video.addEventListener('pause', () => {
      videoOverlays[indexCurrent].classList.remove('hidden');
      video.classList.add('hide-controls');
    })
    video.addEventListener('play', () => {
      videoOverlays[indexCurrent].classList.add('hidden');
      video.classList.remove('hide-controls');
      allVideos.forEach((otherVideo, indexOther) => {
        if (otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
        }
      });
    });
  });

});

// const showOverlay = ( video ) => {
//   console.log( video );
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-needs"] && !Shopify.designMode) return;
  try {
    

document.addEventListener( 'DOMContentLoaded', function() {

    const splideNeeds = new Splide( '.splide-section-needs', {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      
      autoplay: false,
      pagination: false,
      arrows: false,
      // focus: 'center',
      gap: 20,
      breakpoints: {
        1024: {
          type: 'slide',
          perPage: 2.2,
          gap: 10, 
          focus: 'center'
          // padding: { right: 90 }
        },
        640: {
          perPage: 1.25,
          // padding: { right: 70 }
        },
      }
  });

  splideNeeds.mount({});


});

// const showOverlay = ( video ) => {
//   console.log( video );
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrivo-day-system"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-th-day]');
    if (!sections.length) return;
    var mqDesktop = window.matchMedia('(min-width: 1024px)');
    var HEADER = 110;

    function setActive(section, i) {
      var sky = section.querySelector('[data-th-day-sky]');
      if (!sky || sky.getAttribute('data-active') === String(i)) return;
      sky.setAttribute('data-active', String(i));
      section.querySelectorAll('[data-th-day-st]').forEach(function (st, n) {
        st.classList.toggle('is-active', n === i);
      });
    }

    function update() {
      sections.forEach(function (section) {
        var stations = section.querySelectorAll('[data-th-day-st]');
        var count = stations.length;
        if (!count) return;
        var light = section.querySelector('.th-day__light');
        if (mqDesktop.matches) {
          var track = section.querySelector('[data-th-day-track]');
          var r = track.getBoundingClientRect();
          var distance = r.height - (window.innerHeight - HEADER);
          var p = distance > 0 ? Math.min(1, Math.max(0, (HEADER - r.top) / distance)) : 0;
          // aktívny produkt = najbližšia zastávka (ráno 0, obed 0.5, večer 1)
          var i = Math.min(count - 1, Math.round(p * (count - 1)));
          setActive(section, i);
          // svetlo ide plynule po oblúku Q(0,460)(600,-140)(1200,460) medzi t=1/6 a t=5/6
          if (light) {
            var t = 1 / 6 + p * (4 / 6), u = 1 - t;
            var bx = 2 * u * t * 600 + t * t * 1200;
            var by = u * u * 460 + 2 * u * t * -140 + t * t * 460;
            light.style.left = (bx / 12) + '%';
            light.style.top = (by / 4.6) + '%';
          }
          var sky = section.querySelector('[data-th-day-sky]');
          if (sky) sky.classList.toggle('is-scrolled', p > 0.03);
        } else {
          if (light) { light.style.left = ''; light.style.top = ''; }
          var mid = window.innerHeight / 2, best = 0, bestD = Infinity;
          stations.forEach(function (st, n) {
            var b = st.getBoundingClientRect();
            var d = Math.abs(b.top + b.height / 2 - mid);
            if (d < bestD) { bestD = d; best = n; }
          });
          setActive(section, best);
        }
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrivo-faq-chat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(section) {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';
      var log = section.querySelector('[data-th-faq-log]');
      var chips = section.querySelector('[data-th-faq-chips]');
      var done = section.querySelector('[data-th-faq-done]');
      var pick = section.querySelector('[data-th-faq-pick]');
      var avatarTpl = section.querySelector('[data-th-faq-avatar]');
      var busy = false;

      function row(kind) {
        var r = document.createElement('div');
        r.className = 'th-fq__row th-fq__row--' + kind;
        if (kind === 'bot' && avatarTpl) r.appendChild(avatarTpl.content.cloneNode(true));
        return r;
      }
      function addUser(text) {
        var r = row('user');
        var b = document.createElement('div');
        b.className = 'th-fq__bubble th-fq__bubble--user';
        b.textContent = text;
        r.appendChild(b);
        log.appendChild(r);
      }
      function addBot(i) {
        var tpl = section.querySelector('[data-th-faq-a="' + i + '"]');
        var r = row('bot');
        var b = document.createElement('div');
        b.className = 'th-fq__bubble th-fq__bubble--bot';
        if (tpl) b.appendChild(tpl.content.cloneNode(true));
        r.appendChild(b);
        log.appendChild(r);
      }
      function ask(btn, instant) {
        if (busy) return;
        var i = btn.getAttribute('data-th-faq-q');
        var label = btn.querySelector('.th-fq__chip-text');
        var text = (label || btn).textContent.trim();
        btn.remove();
        if (!chips.querySelector('[data-th-faq-q]')) {
          if (done) done.hidden = false;
          if (pick) pick.hidden = true;
        }
        addUser(text);
        if (instant) { addBot(i); return; }
        busy = true;
        var t = row('bot');
        var dots = document.createElement('div');
        dots.className = 'th-fq__bubble th-fq__bubble--bot th-fq__typing';
        dots.setAttribute('aria-label', 'THRIVO píše');
        dots.innerHTML = '<i></i><i></i><i></i>';
        t.appendChild(dots);
        log.appendChild(t);
        setTimeout(function () { t.remove(); addBot(i); busy = false; }, 900);
      }

      chips.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-th-faq-q]');
        if (btn) ask(btn, false);
      });
      // prvá otázka je zodpovedaná hneď, aby chat nebol prázdny
      var first = chips.querySelector('[data-th-faq-q]');
      if (first) ask(first, true);
    }
    function run() { document.querySelectorAll('[data-th-faq]').forEach(initFaq); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrivo-founder"] && !Shopify.designMode) return;
  try {
    
  /* stena sa hýbe len keď je sekcia na obrazovke */
  (function () {
    function init() {
      document.querySelectorAll('[data-th-fd]').forEach(function (el) {
        if (el._thObs) return;
        if (!('IntersectionObserver' in window)) { el.classList.remove('th-fd--paused'); return; }
        el._thObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { el.classList.toggle('th-fd--paused', !e.isIntersecting); });
        }, { rootMargin: '100px 0px' });
        el._thObs.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrivo-gallery"] && !Shopify.designMode) return;
  try {
    
  /* Pásy spúšťa assets/th-marquee.js (načítaný v layoute) – tu len pre istotu po vykreslení sekcie. */
  if (window.thrivoInitMarquees) window.thrivoInitMarquees();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrivo-people"] && !Shopify.designMode) return;
  try {
    
  /* Pásy spúšťa assets/th-marquee.js (načítaný v layoute) – tu len pre istotu po vykreslení sekcie. */
  if (window.thrivoInitMarquees) window.thrivoInitMarquees();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrivo-products-need"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-th-need-track]').forEach(function (track) {
      var section = track.closest('.th-need');
      var dots = section ? section.querySelectorAll('.th-need__dot') : [];
      if (!dots.length) return;
      track.addEventListener('scroll', function () {
        var cards = track.children;
        if (!cards.length) return;
        var step = cards[0].getBoundingClientRect().width + 12;
        var i = Math.round(track.scrollLeft / step);
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) i = cards.length - 1;
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrivo-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Pásy spúšťa assets/th-marquee.js (načítaný v layoute) – tu len pre istotu po vykreslení sekcie. */
  if (window.thrivoInitMarquees) window.thrivoInitMarquees();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thrivo-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';
      var track = section.querySelector('[data-th-vd-track]');
      var videos = [].slice.call(section.querySelectorAll('video'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      videos.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.removeAttribute('autoplay'); });

      // úvodné obrázky (poster) až keď je rad videí blízko obrazovky
      function showPoster(v) { if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); }
      if ('IntersectionObserver' in window) {
        var near = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { videos.forEach(showPoster); near.disconnect(); }
        }, { rootMargin: '800px 0px' });
        // až po načítaní stránky – kým sa skladá, je sekcia „blízko“ vrchu a obrázky by sa stiahli hneď
        var started = false;
        var startNear = function () { if (started) return; started = true; near.observe(section); };
        if (document.readyState === 'complete') startNear(); else { window.addEventListener('load', startNear, { once: true }); setTimeout(startNear, 2500); }
        // ak zákazník scrolluje skôr, ako sa stránka načíta
        window.addEventListener('scroll', startNear, { once: true, passive: true });
      } else { videos.forEach(showPoster); }

      // prehrávať len videá na obrazovke; načítajú sa až pri priblížení (preload none)
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting && e.intersectionRatio > 0.5) {
              var p = v.play(); if (p && p.catch) p.catch(function () {});
            } else if (!v.paused) { v.pause(); }
          });
        }, { threshold: [0, 0.5, 1] });
        videos.forEach(function (v) { io.observe(v); });
      }

      var prev = section.querySelector('[data-th-vd-prev]');
      var next = section.querySelector('[data-th-vd-next]');
      function step() { var c = track.querySelector('.th-vd__card'); return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : 300; }
      function update() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
      }
      function goTo(i) { var s = step(); track.scrollTo({ left: Math.max(0, i) * s, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { goTo(Math.round(track.scrollLeft / step()) - 2); });
      if (next) next.addEventListener('click', function () { goTo(Math.round(track.scrollLeft / step()) + 2); });
      // ťahanie myšou (na dotykových zariadeniach stačí natívne posúvanie)
      var drag = null, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { x: e.clientX, left: track.scrollLeft };
        moved = false;
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
        if (moved) { e.preventDefault(); track.scrollLeft = drag.left - dx; }
      });
      window.addEventListener('pointerup', function () {
        if (!drag) return;
        drag = null;
        if (moved) {
          track.classList.remove('is-dragging');
          // dočiahne na najbližšie video
          goTo(Math.round(track.scrollLeft / step()));
        }
      });
      // po ťahaní nespustiť klik na odkaz
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function run() { document.querySelectorAll('[data-th-vd]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
